import React, {
	ChangeEvent,
	MutableRefObject,
	useEffect,
	useRef,
	useState,
} from "react";
import { ThemeModesTypes } from "../../settingsComp/SettingsTypes";
import { InputGroupPropsTypes } from "../../inputComp/InputGroupType";
import AlertDialog from "../../popupComp/AlertDialog";
import {
	CloseIcon,
	CountryIcon,
	EmailIcon,
	MobileIcon,
	SearchIcon,
	UserIcon,
} from "../../iconSet/IconSet";
import InputGroup from "../../inputComp/InputGroup";
import { sideFieldCount } from "../../createWarningComp/CommonMethods";
import { SelectItemTypes } from "../../../CommonTypes";
import GroupsTable, { GroupTableType } from "./GroupsTable";
import {
	APICallGenerateProcKeyRequest,
	APICallGetAllSubscriberRequest,
	APICallNewSubscriberRequest,
	APISubscriberType,
	APISubscribeUserNewTypes,
} from "../../../services/APIEarlyWarningService";
import GroupSelectTable from "../../warningWorkflowProcessComp/GroupSelectTable";
import { GroupDataRow } from "../../earlyWarning/emailComp/EmailTypes";
import useInputValidate from "../../../hooks/useInputValidate";
import AreasTable from "./AreasTable";
import HazardsTable, { HazardType } from "./HazardsTable";

import loadLightIcon from '../../../images/icons/load-light.gif'
import loadDarkIcon from '../../../images/icons/load-dark.gif'
import { useTheme } from "../../../context/ThemeContext";
import LoadingScreen from "../../loadingScreenComp/LoadingScreen";

type NotifyType = {
	id: string;
	name: string;
	ref: MutableRefObject<HTMLInputElement | null>;
};

const Subscribe = () => {
	// Loading screen
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const { validateField } = useInputValidate();
	const { theme } = useTheme()

	const [isUpdate, setIsUpdate] = useState(false);

	const [alertDialogState, setAlertDialogState] = useState(false);
	const [alertTitle, setAlertTitle] = useState("");
	const [alertDescription, setAlertDescription] = useState("");
	const [alertYesCallback, setAlertYesCallback] = useState<
		(() => void) | undefined
	>(undefined); // for Yes
	const [alertOkCallback, setAlertOkCallback] = useState<
		(() => void) | undefined
	>(undefined); // for OK

	const [isLoad, setIsLoad] = useState<boolean>(false);

	const showAlertDialog = (
		title: string,
		description: string,
		yesCallback?: () => void,
		okCallback?: () => void
	) => {
		setAlertTitle(title);
		setAlertDescription(description);
		setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
		setAlertOkCallback(() => okCallback); // Will trigger only on OK
		setAlertDialogState(true);
	};

	const allSubscribers = useRef<APISubscriberType[]>([]);
	const [filteredSubscribersData, setFilteredSubscribersData] = useState<
		APISubscriberType[]
	>([]);

	const [subscriberTypes, setSubscriberTypes] = useState<any[]>([
		{ name: "test user", value: "test_user" },
		{ name: "system user", value: "system_user" },
	]);

	const [subscriberLanguage, setSubscriberLanguage] = useState<any[]>([
		{ name: "English", value: "EN" },
		{ name: "Dhivehi", value: "DV" },
		{ name: "Bengali", value: "BE" },
		// { name: "Sinhala", value: "SN" },
		// { name: "Tamil", value: "TA" },
	]);

	const [isDataPickerOpen, setIsDataPickerOpen] = useState<boolean>(false);
	const [isDataPickerLoading, setIsDataPickerLoading] = useState<boolean>(false);

	const [titleName, setTitleName] = useState<string>("setup subscribers");

	const BASE_URL = process.env.REACT_APP_BASE_URL;

	const [selectedGroups, setSelectedGroups] = useState<GroupDataRow[]>([]);
	const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
	const [selectedHazardTypes, setSelectedHazardTypes] = useState<HazardType[]>([]);
	const [selectedHazard, setSelectedHazard] = useState<string[]>([]);

	// Form fields
	const subscriberIdRef = useRef<HTMLInputElement | null>(null);
	const subscriberFirstNameRef = useRef<HTMLInputElement | null>(null);
	const subscriberLastNameRef = useRef<HTMLInputElement | null>(null);
	const subscriberMobileNumberRef = useRef<HTMLInputElement | null>(null);
	const subscriberEmailRef = useRef<HTMLInputElement | null>(null);
	const subscriberTypeRef = useRef<HTMLSelectElement | null>(null);
	const subscriberLanguageRef = useRef<HTMLSelectElement | null>(null);

	const smsRef = useRef<HTMLInputElement | null>(null);
	const whatsappRef = useRef<HTMLInputElement | null>(null);
	const viberRef = useRef<HTMLInputElement | null>(null);

	const notifyType: NotifyType[] = [
		{ id: "sms", name: "SMS", ref: smsRef },
		{ id: "whatsapp", name: "Whatsapp", ref: whatsappRef },
		{ id: "viber", name: "Viber", ref: viberRef },
	];

	const formItems: InputGroupPropsTypes[] = [
		{
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Subscriber Id",
			label: "id",
			componentInputElement: subscriberIdRef,
			name: "subscriber-id",
			required: true,
			dataPicker: true,
			isDataPickerOpen: isDataPickerOpen,
			setIsDataPickerOpen: setIsDataPickerOpen,
			disabled: true,
		},
		{
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Subscriber First Name",
			label: "subscriber first name",
			componentInputElement: subscriberFirstNameRef,
			name: "subscriber-first-name",
			required: true,
		},
		{
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Subscriber Last Name",
			label: "subscriber last name",
			componentInputElement: subscriberLastNameRef,
			name: "subscriber-first-name",
			required: false,
		},
		{
			type: "text",
			icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Subscriber Mobile Number",
			label: "subscriber mobile number",
			componentInputElement: subscriberMobileNumberRef,
			name: "subscriber-mobile-number",
			required: true,
		},
		{
			type: "text",
			icon: <EmailIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Subscriber Email",
			label: "subscriber email",
			componentInputElement: subscriberEmailRef,
			name: "subscriber-mobile-number",
			required: true,
		},
		{
			type: "select",
			icon: <EmailIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "subscriber type",
			componentSelectElement: subscriberTypeRef,
			name: "subscriber-type",
			placeholder: "Select Subscriber Type",
			optionList: subscriberTypes,
			required: true,
		},
		{
			type: "select",
			icon: <EmailIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "subscriber language",
			componentSelectElement: subscriberLanguageRef,
			name: "subscriber-language",
			placeholder: "Select Subscriber Language",
			optionList: subscriberLanguage,
			required: true,
		},
	];

	const getSelectedGroups = (): string[] => {
		const selectedGroup: string[] = [];
		selectedGroups.map((item, index) => {
			selectedGroup.push(item.groupid);
		});
		return selectedGroup;
	};

	const getSelectedAreas = (): string[] => {
		return selectedAreas;
	};

	const getSelectedhazardTypes = (): string[] => {
		const selectedHazard: string[] = [];
		selectedHazardTypes.map((item, index) => {
			selectedHazard.push(item.code);
		});
		return selectedHazard;
	};


	const handleSave = async () => {
		const subscriberFirstName = validateField(subscriberFirstNameRef);
		setIsLoading(true)
		if (subscriberFirstName) {
			if (
				subscriberIdRef.current &&
				subscriberFirstNameRef.current &&
				subscriberLastNameRef.current &&
				subscriberMobileNumberRef.current &&
				subscriberEmailRef.current &&
				smsRef.current &&
				whatsappRef.current &&
				viberRef.current &&
				subscriberTypeRef.current &&
				subscriberLanguageRef.current
			) {
				const newSubmitData: APISubscribeUserNewTypes = {
					id: subscriberIdRef.current.value,
					firstName: subscriberFirstNameRef.current.value,
					lastName: subscriberLastNameRef.current.value,
					mobileNumber: subscriberMobileNumberRef.current.value,
					email: subscriberEmailRef.current.value,
					sms: smsRef.current.checked ? true : false,
					whatsapp: whatsappRef.current.checked ? true : false,
					viber: viberRef.current.checked ? true : false,
					groups: getSelectedGroups(),
					areas: getSelectedAreas(),
					hazards: getSelectedhazardTypes(),
					userType: subscriberTypeRef.current.value,
					language: subscriberLanguageRef.current.value
				};
				
				const response = await APICallNewSubscriberRequest(newSubmitData);

				setIsLoading(false)

				if (response.httpStatus === "OK") {
					console.log("successfully added subscriber");
					showAlertDialog(
						"Success",
						"✅ Successfully save subscriber!",
						undefined,
						() => window.location.reload()
					);
				} else {
					console.log("fail adding subscriber");
					showAlertDialog("Error", "❌ Error adding data");
				}
			}
		}
	};

	const handleChangeExistingDataSearch = (
		event: ChangeEvent<HTMLInputElement>
	) => {
		if (event.target.value === "") {
			setFilteredSubscribersData(allSubscribers.current);
		} else {
			setFilteredSubscribersData(
				allSubscribers.current.filter((item) =>
					item.firstName
						.toLowerCase()
						.startsWith(event.target.value.toLowerCase())
				)
			);
		}
	};

	const loadAllSubscribers = async () => {
		setIsDataPickerLoading(true)
		const response = await APICallGetAllSubscriberRequest();

		if (response.httpStatus === "OK") {
			allSubscribers.current = response.data;
			setFilteredSubscribersData(response.data);
		} else {
			console.error("❌ Error fetching data");
		}
		setIsDataPickerLoading(false)
	};

	const handleClickFilteredSubscribers = (sub: APISubscriberType) => {
		if (
			subscriberIdRef.current &&
			subscriberFirstNameRef.current &&
			subscriberLastNameRef.current &&
			subscriberMobileNumberRef.current &&
			subscriberEmailRef.current &&
			subscriberTypeRef.current &&
			smsRef.current &&
			whatsappRef.current &&
			viberRef.current &&
			subscriberLanguageRef.current
		) {
		
			subscriberIdRef.current.value = sub.id;
			subscriberFirstNameRef.current.value = sub.firstName;
			subscriberLastNameRef.current.value = sub.lastName;
			subscriberMobileNumberRef.current.value = sub.mobileNumber;
			subscriberEmailRef.current.value = sub.email;
			subscriberTypeRef.current.value = sub.userType;
			subscriberLanguageRef.current.value = sub.language;

			smsRef.current.checked = sub.sms;
			whatsappRef.current.checked = sub.whatsapp;
			viberRef.current.checked = sub.viber;

			const groups: GroupDataRow[] = sub.groups.map((item) => ({
				groupid: item.id,
				groupname: item.groupName,
				department: item.groupDepartment,
				select: true,
				departmentName: item.groupDepartment,
				organizationName: item.groupOrganization
			}));

			setSelectedAreas(sub.areas!)
			setSelectedHazard(sub.hazards!)
			setSelectedGroups(groups);
			//console.log("SELECTED GROUPS -> ", groups)
		}

		setIsDataPickerOpen(false);
		setIsUpdate(true);
	};

	useEffect(() => {
		loadAllSubscribers();
	}, []);

	useEffect(() => {
		const fetchInitialData = async () => {
			try {
				const response = await APICallGenerateProcKeyRequest("SRB"); // Pass prop here
				if (response && !response.errorCode) {
					//console.log("✅ API data loaded: ", response);
					// Example: store a process key in state
					// setProcKey(response.processKey);

					if (subscriberIdRef.current) {
						subscriberIdRef.current.value = response.data;
					}
				} else {
					console.warn("⚠️ API returned an error:", response?.errorMessage);
					showAlertDialog("Error", "Failed to load initial data");
				}
			} catch (error) {
				console.error("❌ Error fetching data:", error);
				showAlertDialog("Network Error", "Failed to fetch initial data.");
			}
		};

		fetchInitialData();
	}, []);

	const handleDeleteSubscriber = async () => {
		const token = localStorage.getItem("access_token");
		if (!token) {
			showAlertDialog("Unauthorized", "Missing access token.");
			return;
		}

		if (subscriberIdRef.current) {
			try {
				setIsLoading(true)
				//const response = await fetch(`https://bos.beconx.live/api/v1/delete/${form.username}`,
				const response = await fetch(
					BASE_URL +
						`/ew/api/v1/delete_subscribers?id=${subscriberIdRef.current.value}`,
					{
						method: "GET",
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				);

				setIsLoading(false)

				if (response.ok) {
					setIsUpdate(false);
					showAlertDialog(
						"Deleted",
						"✅ Subscriber deleted successfully",
						undefined,
						() => window.location.reload()
					);
				} else {
					const contentType = response.headers.get("content-type");
					if (contentType && contentType.includes("application/json")) {
						const error = await response.json();
						console.log(error.message || "Error deleting subscriber");
						showAlertDialog("Error", "Error deleting subscriber");
					} else {
						const errorText = await response.text();
						console.log(errorText);
						showAlertDialog("Error", "Error deleting subscriber");
					}
				}
			} catch (err) {
				console.error("Delete failed", err);
				console.log("An error occurred during deletion");
			}
		}
	};

	return (
		<div className={`container-wrapper`}>
			<span className={`title`}>{titleName}</span>

			<div className={`add-subscribers`}>
				<div className={`grid-layout-add-subscribers`}>
					<div className={`left-side`}>
						{formItems
							.slice(0, 7/* sideFieldCount(formItems.length) */)
							.map((field, index) => (
								<InputGroup key={index} {...field} />
							))}
							<div style={{width:'100%'}} className="message-type-selector">
							<div style={{width:'100%', padding: '1rem 0.65rem 0.0rem 0.65rem'}} className={`checkbox-container`}>
								<span className={`title`}>Notify type</span>
								<div
									style={{
										gridTemplateColumns:
											"repeat(auto-fit, minmax(5rem, 5fr/* 10rem */))",
									}}
									className={"wrapper"}
								>
									{notifyType.map((item, index) => (
										<div key={index} className={`item`}>
											<input
												type="checkbox"
												name="accessprivileges"
												id="ur_checkbox_megha"
												ref={item.ref}
											/>
											<label htmlFor="ur_checkbox_megha">{item.name}</label>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
					<div className={`right-side`}>
						{/* {formItems
							.slice(4)
							.map((field, index) => (
								<InputGroup key={index} {...field} />
							))} */}
						
						<div style={{ height:"100%",  padding:'1.8rem 0.65rem 0.0rem 0.65rem' }}>
							<HazardsTable
								hazards= {selectedHazard}
								onSelectHazards={setSelectedHazardTypes}
							/>
						</div>
					</div>
					<div
						className={`table-wrapper-1`}
						style={{ display: "flex", gap: "0rem", padding: '1rem 0.65rem 0.0rem 0.65rem'}}
					>
							<GroupsTable
								groups={selectedGroups}
								setGroups={setSelectedGroups}
							/>
						{/* <div style={{ flex: 0 }}>
							<HazardsTable
								hazards= {selectedHazard}
								onSelectHazards={setSelectedHazardTypes}
							/>
						</div> */}
					</div>
					<div
						className={`table-wrapper-2`}
						style={{ display: "flex", gap: "0rem", padding: '1rem 0.65rem 0.0rem 0.65rem'}}
					>
							<AreasTable
							areas={selectedAreas}
								title={"Select Areas"}
								onSelect={setSelectedAreas}
							/>
						{/* <div style={{ flex: 0 }}>
							<HazardsTable
								hazards= {selectedHazard}
								onSelectHazards={setSelectedHazardTypes}
							/>
						</div> */}
					</div>
					<div className={`button-wrapper`} style={{ gridArea: "button" }}>
						<div className={`left-side`}></div>
						<div className={`right-side`}>
							<button className={`button-normal`} onClick={(e) => showAlertDialog("Confirm Save", "Are you sure you want to save this subscriber?", () => handleSave())}>
								{isUpdate ? "Update" : "Create"}
							</button>
							{isUpdate && (
								<button className={`button-normal`} style={{ backgroundColor: "var(--color-main-red)" }} onClick={ (e) => showAlertDialog("Confirm Delete", "Are you sure you want to delete this subscriber?", () => handleDeleteSubscriber())} >
									Delete
								</button>
							)}
						</div>
					</div>
					{isDataPickerOpen && (
						<div className="data-picker-table-wrapper">
							<div className="data-picker-table-container">
								<div className="search-wrapper">
									<input
										type="text"
										placeholder="Search Subscribers"
										onChange={(e) => handleChangeExistingDataSearch(e)}
									/>
									<div className="search-icon">
										<SearchIcon width="1rem" color="var(--color-main-white)" />
									</div>
									<div
										className="close-icon"
										onClick={(e) => setIsDataPickerOpen(false)}
									>
										<CloseIcon width="1.5rem" color="var(--color-text)" />
									</div>
								</div>
								<div className="row header">
									<span style={{ width: '33%' }}>First Name</span>
									<span style={{ width: '33%' }}>Email</span>
									<span style={{ width: '33%' }}>User Type</span>
								</div>

								{isDataPickerLoading ? (
									<div className="searching-data">
										<img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
										<span>Searching subscriber data...</span>
									</div>
									) : (
										<div className="data-wrapper">
											{filteredSubscribersData.map((sub, index) => (
												<div
													key={index}
													className="row"
													onClick={(e) => handleClickFilteredSubscribers(sub)}
												>
													<span style={{ width: '33%'}}>{sub.firstName}</span>
													<span style={{ width: '33%'}}>{sub.email}</span>
													<span style={{ width: '33%'}}>{sub.userType === 'test_user' ? 'Test User' : sub.userType === 'system_user' ? 'System User' : 'N/A'}</span>
												</div>
											))}
										</div>
									)}
							</div>
						</div>
					)}
				</div>
			</div>
			{alertDialogState && (
				<AlertDialog
					title={alertTitle}
					description={alertDescription}
					windowState={alertDialogState}
					setWindowState={setAlertDialogState}
					function={alertYesCallback}
					okFunction={alertOkCallback}
				/>
			)}
			{isLoading && (
                <LoadingScreen />
            )}
		</div>
	);
};

export default Subscribe;
